import { SkillValue } from "../../../services/api/instances/skillsApi/types";

export const getUpdatedSkillValue = (
  value: SkillValue,
  fields: Partial<SkillValue["skill_object"]> = {},
): SkillValue => ({
  skill_object: {
    ...value.skill_object,
    ...fields,
  },
});
